// TIP-494 (MV Stage 5) — the dashboard "Membership" page. Header + the
// state-driven body (MembershipStatusCard), keyed to the active company. Design
// per the approved comp: plan selector (claimed), dual membership/verification
// panel (member), verified confirmation (verified). Distinct from the public
// checkout page at /membership/:companyId.
import React from "react";
import MembershipStatusCard from "../../../components/admin/Dashboard/membership/MembershipStatusCard";

const Membership = () => {
  return (
    // Use the dashboard shell's default padding (py-4 px-4) like every other
    // page — just cap the width so the plan cards don't stretch on wide screens.
    <div style={{ color: "#002940", textAlign: "left", maxWidth: 1180 }}>
      {/* page header */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 14 }}>
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#FB512D" strokeWidth="1.7" strokeLinejoin="round" style={{ marginTop: 2, flexShrink: 0 }}>
          <path d="M6 3h12l3 5-9 13L3 8Z" fill="#FCEAD0" />
          <path d="M3 8h18M9 3 7 8l5 13M15 3l2 5-5 13" />
        </svg>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 700, color: "#002940", letterSpacing: "-.2px" }}>Membership</h1>
          <p style={{ margin: "5px 0 0", fontSize: 14.5, color: "#5A6B73", maxWidth: 560, lineHeight: 1.5 }}>
            Your TREVEX plan, your verification status, and what each one unlocks for this company.
          </p>
        </div>
      </div>

      <MembershipStatusCard />
    </div>
  );
};

export default Membership;
